// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cFhnLjxnBMFBPQxsuqJe {
  margin: 0 auto;
}

.ZcLLcGgmLqrqHyZ89qEW {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}

.XhP9Lr4TyZHcvSmNjtV_ {
  align-items: center;
}
@media screen and (min-width: 800px) {
  .XhP9Lr4TyZHcvSmNjtV_ {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/pages/notFound/NotFound.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;AAAE;EAFF;IAGI,aAAA;EAGF;AACF","sourceRoot":""}]);
// Exports
export var section = `cFhnLjxnBMFBPQxsuqJe`;
export var column = `ZcLLcGgmLqrqHyZ89qEW`;
export var columns = `XhP9Lr4TyZHcvSmNjtV_`;
export default ___CSS_LOADER_EXPORT___;
